import { z } from 'zod'
import { fallback } from '../../../../utilities'
import { colorSchema } from './colors'

const fallbackData = {
	backgroundColor: 'white',
	backgroundShapeSticky: 'none',
}

const backgroundColorSchema = colorSchema.or(fallback(fallbackData.backgroundColor))
const backgroundShapeStickySchema = z.enum(['none', 'top', 'right', 'bottom', 'left']).or(
	fallback(fallbackData.backgroundShapeSticky),
)

export const metaLogoSchema = z.object({
	backgroundColor: backgroundColorSchema,
	backgroundShapeSticky: backgroundShapeStickySchema,
}).or(fallback(fallbackData))

export type MetaLogoConfiguration = z.infer<typeof metaLogoSchema>

export const metaLogoDefault: MetaLogoConfiguration = metaLogoSchema.parse({})
